import * as types from '../mutation-types';
import axios from "axios";

const state = {
  areaList: []
}

const getters = {
  areaList: state => state.areaList,
}

const actions = {
  getArea (context) {
    return new Promise((resolve, reject) => {
        axios.get('/v1/app/common/pcdlinkage').then((response) => {
          let list = response.data.items.children
          if (list && list.length > 0) {
            context.commit(types.AREA_LIST, list)
            resolve(list)
          } else {
            reject(new Error())
          }
        }, (err) => {
           console.log(err)
        })
    })
  }
}

const mutations = {
  [types.AREA_LIST] (state, list) {
    state.areaList = list
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/area.js